<template>
  <div class="hpsfir-card coupon">
    <el-tabs v-model="activeTab" class="coupon-tabs">
      <el-tab-pane label="券类型管理" name="couponType">
        <CouponType v-if="activeTab === 'couponType'" />
      </el-tab-pane>
      <el-tab-pane label="核销记录管理" name="couponRecord">
        <CouponRecord v-if="activeTab === 'couponRecord'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import CouponType from './coupontype/index.vue';
import CouponRecord from './couponrecord/index.vue';

const activeTab = ref('couponType');
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
